import dhtmlXCombo from "./dhtmlXCombo";

export function dhtmlXComboExtend(g, e) {
    for (var c in dhtmlXCombo.prototype.modes[e]) {
        if (typeof (dhtmlXCombo.prototype.modes[g][c]) == "undefined") {
            dhtmlXCombo.prototype.modes[g][c] = dhtmlXCombo.prototype.modes[e][c]
        }
    }
}



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXCombo/commonFun.js